var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer-wrapper" }, [
    _c("footer", { staticClass: "main-footer" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "level is-title" }, [
          _c("div", { staticClass: "level-left" }, [
            _c("div", { staticClass: "level-item" }, [
              _c("nav", [
                _c(
                  "ul",
                  { staticClass: "footer-links" },
                  [
                    _c(
                      "li",
                      [
                        _c("router-link", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: _vm.langRoot + ".termsAndConditions",
                              expression: "`${langRoot}.termsAndConditions`"
                            }
                          ],
                          staticClass: "clickable footer-link",
                          attrs: { tag: "a", to: { name: "terms" } }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c("router-link", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: _vm.langRoot + ".dataPrivacy",
                              expression: "`${langRoot}.dataPrivacy`"
                            }
                          ],
                          staticClass: "clickable footer-link",
                          attrs: { tag: "a", to: { name: "dataprivacy" } }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c("router-link", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: _vm.langRoot + ".cookiePolicy",
                              expression: "`${langRoot}.cookiePolicy`"
                            }
                          ],
                          staticClass: "clickable footer-link",
                          attrs: { tag: "a", to: { name: "cookiepolicy" } }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.links, function(link, index) {
                      return _c("li", { key: "link--" + index }, [
                        _c(
                          "a",
                          {
                            staticClass: "footer-link",
                            attrs: { href: link.href, target: "_blank" }
                          },
                          [
                            _c("i8-icon", {
                              staticClass: "icon footer-link__icon",
                              attrs: { icon: link.icon }
                            }),
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t(_vm.langRoot + ".security")) +
                                "\n                  "
                            )
                          ],
                          1
                        )
                      ])
                    })
                  ],
                  2
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "level-right" }, [
            _c("div", { staticClass: "level-item" }, [
              _c("li", [
                _vm._v(
                  _vm._s(
                    _vm.$t(_vm.langRoot + ".copyrightNotice", {
                      copyrightSymbol: "©",
                      year: _vm.currentYear
                    })
                  )
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e59caf90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e59caf90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./shared/components/Footer.vue
// module id = /JM7
// module chunks = 0 1 2